import qs from 'qs';
import { api } from '../api';

const updateJourneyState = (journeyState) =>
  api.fetchJSON('journey-state', {
    method: 'PUT',
    body: journeyState,
  });

const getDecodedJourneyState = (token) =>
  api.fetchJSON(`journey-state?${qs.stringify({ token }, { skipNulls: true })}`);

export const journeyStateApi = {
  updateJourneyState,
  getDecodedJourneyState,
};
